<script>
import ElementsInput from '@/components/elements/ElementsInput.vue';
import ElementsModal2Button from '@/components/elements/ElementsModal2Button.vue';
import { DotsVerticalIcon } from '@heroicons/vue/outline';
import { graduationCategory } from '@/assets/data/optionData.js';
import { educationTypes } from '@/assets/data/optionData.js';
import AppPopup from '@/components/AppPopup.vue';
import moment from 'moment';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignInput from '@/components/design-system/design-input.vue';
import DesignDropdown from '@/components/design-system/design-dropdown.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignDatepicker from '@/components/design-system/design-datepicker.vue';
import AddIcon from '@/components/design-system/icon/add.vue';

export default {
    components: {
        ElementsInput,
        AppPopup,
        ElementsModal2Button,
        DotsVerticalIcon,
        DesignButton,
        DesignInput,
        DesignDropdownSelect,
        DesignDatepicker,
        AddIcon,
    },
    props: {
        selectedEmployeeSeq: String,
    },

    data() {
        return {
            // 디비에서 가지고 와서 저장
            educations: [],
            // add
            popupItems: {
                employeeSeq: this.selectedEmployeeSeq,
                schoolName: null,
                degreeType: null,
                major: null,
                admissionDate: null,
                graduationDate: null,
                graduationCategory: null,
            },
            // edit
            popupEditItems: {
                employeeSeq: this.selectedEmployeeSeq,
                schoolName: null,
                degreeType: null,
                major: null,
                admissionDate: null,
                graduationDate: null,
                graduationCategory: null,
            },
            // modal
            showCancelCheckModal: false,
            showEditPopup: false,
            showPopup: false,

            educationSeq: null,
            requestItem: [],
            beforeEditData: {},
            saveData: {},
            graduationCategoryOptions: graduationCategory,
            educationTypes: educationTypes,
            showEditBtn: false,
        }; //return
    }, //data
    mounted() {
        this.getListEducation(this.selectedEmployeeSeq);
    },
    methods: {
        moment: moment,
        parseInt: parseInt,
        deleteEducationModalOpen() {
            const self = this;
            self.showEditPopup = false;
            self.showCancelCheckModal = true;
        },
        //데이터 삭제
        deleteEducation() {
            const self = this;
            const params = new URLSearchParams(document.location.search);
            params.append('educationSeq', self.educationSeq);
            const url = self.$api('uri', 'delete-employee-education').replace('{educationSeq}', self.educationSeq);
            self.$axios
                .delete(url)
                .then((res) => {
                    self.showCancelCheckModal = false;
                    self.getListEducation(self.selectedEmployeeSeq);
                })
                .catch(console.log);
        },
        getListEducation(employeeSeq) {
            const self = this;
            const url = self.$api('uri', 'get-employee-education').replace('{employeeSeq}', employeeSeq);

            self.$axios
                .get(url)
                .then((res) => {
                    self.educations = res.data.data.list;
                    self.showEditBtn = true;
                })
                .catch((err) => (self.showEditBtn = false));
        },
        saveEducationAdd() {
            const self = this;

            if (!self.validationEducation(self.popupItems)) {
                return;
            }
            const employeeSeq = self.selectedEmployeeSeq;
            const requestItem = { ...self.popupItems, employeeSeq };

            const url = self.$api('uri', 'post-employee-education');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    self.showPopup = false;
                    self.getListEducation(employeeSeq);
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        addButtonClick() {
            const self = this;
            self.showPopup = true;
            self.popupItems = {
                employeeSeq: this.selectedEmployeeSeq,
                schoolName: null,
                degreeType: null,
                major: null,
                admissionDate: null,
                graduationDate: null,
                graduationCategory: null,
            };
        },
        editButtonClick(arg) {
            const self = this;
            self.showEditPopup = true;
            self.nowEdit = true;

            self.popupEditItems = { ...arg };
            self.educationSeq = self.popupEditItems.educationSeq;
        },
        editSaveButtonClick() {
            const self = this;

            if (!self.validationEducation(self.popupEditItems)) {
                return;
            }

            const employeeSeq = self.selectedEmployeeSeq;
            const requestItem = { ...self.popupEditItems, employeeSeq };

            const url = self.$api('uri', 'put-employee-education');
            self.$axios
                .put(`${url}/${encodeURIComponent(self.educationSeq)}`, requestItem)
                .then((res) => {
                    self.showEditPopup = false;
                    self.getListEducation(employeeSeq);
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        validationEducation(itemToValidate) {
            let { schoolName, admissionDate, graduationDate } = itemToValidate;

            if (schoolName === null || schoolName === '') {
                alert('School Name can’t be blank');
                return false;
            }

            if (parseInt(graduationDate) < parseInt(admissionDate)) {
                alert('Please enter the correct date');
                return false;
            }

            return true;
        },
        toDatePickerValue(value) {
            if (!value) {
                return null;
            }
            if (value instanceof Date) {
                return value;
            }
            return moment(String(value), 'YYYYMMDD').toDate();
        },
    },
};
</script>
<template>
    <div>

        <!-- Modal Add Education START -->
        <Teleport to="body">
            <AppPopup v-model="showPopup" name="Add Education" max-width='640px'>
                <div class="p-6 pt-1">
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Type</div>
                        <DesignDropdownSelect
                            v-model="popupEditItems.degreeType" 
                            placeholder="Please select Type" 
                            dixr="LG"
                            width="w-full"
                            :options="educationTypes"
                            class="flex-1"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">School Name</div>
                        <DesignInput v-model="popupItems.schoolName" placeholder="Please enter School Name" class="flex-1" :full="true"/>
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Major</div>
                        <DesignInput v-model="popupItems.major" placeholder="Please enter Major" class="flex-1" :full="true" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Admission Date</div>
                        <DesignDatepicker
                            :modelValue="toDatePickerValue(popupItems.admissionDate)"
                            @update:output="popupItems.admissionDate = $event"
                            placeholder="Select Date"
                            class="flex-1 w-[420px]"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Graduation Date (including planned)</div>
                        <DesignDatepicker
                            :modelValue="toDatePickerValue(popupItems.graduationDate)"
                            @update:output="popupItems.graduationDate = $event"
                            placeholder="Select Date"
                            class="flex-1 w-[420px]"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Graduation Category</div>
                        <ElementsSelectRef
                            v-model="popupItems.graduationCategory"
                            placeholder="Please select Graduation Category"
                            class="flex-1"
                            :options="graduationCategoryOptions"
                            :full="true"
                            :useDefaultMsg="true" />
                    </div>
                </div>
                <div class="flex w-full bg-white">
                    <div class="w-full p-4 border-t-1 border-border-basic-2 justify-end flex gap-2">
                        <DesignButton btnType="SECONDARY" btnVariant="BORDER" btnText="Cancel" class="w-[6rem]" @click="showPopup = false"/>
                        <DesignButton btnType="PRIMARY" btnVariant="FILL" btnText="Save" class="w-[6rem]" @click="saveEducationAdd"/>
                    </div>
                </div>
            </AppPopup>
        </Teleport>
        <!-- Modal Add Education END -->

        <!-- Modal Edit Education START -->
        <Teleport to="body">
            <AppPopup v-model="showEditPopup" name="Edit Education" max-width='640px'>
                <div class="p-6 pt-1">
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Type</div>
                        <DesignDropdownSelect
                            v-model="popupEditItems.degreeType" 
                            placeholder="Please select Type" 
                            dixr="LG"
                            width="w-full"
                            :options="educationTypes"
                            class="flex-1"    
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">School Name</div>
                        <DesignInput v-model="popupEditItems.schoolName" placeholder="Please enter School Name" class="flex-1" :full="true" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Major</div>
                        <DesignInput v-model="popupEditItems.major" placeholder="Please enter Major" class="flex-1" :full="true" />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Admission Date</div>
                        <DesignDatepicker
                            :modelValue="toDatePickerValue(popupEditItems.admissionDate)"
                            @update:output="popupEditItems.admissionDate = $event"
                            placeholder="Select Date"
                            class="flex-1 w-[420px]"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Graduation Date (Including Planned)</div>
                        <DesignDatepicker
                            :modelValue="toDatePickerValue(popupEditItems.graduationDate)"
                            @update:output="popupEditItems.graduationDate = $event"
                            placeholder="Select Date"
                            class="flex-1 w-[420px]"
                        />
                    </div>
                    <div class="flex justify-between items-center gap-2 mt-4">
                        <div class="c_label w-[10rem]">Graduation Category</div>
                        <DesignDropdownSelect
                            v-model="popupEditItems.graduationCategory" 
                            placeholder="Please select Graduation Category" 
                            dixr="LG"
                            width="w-full"
                            :options="graduationCategoryOptions"
                            :useDefaultMsg="true" 
                            class="flex-1"    
                        />
                    </div>
                    
                </div>
                <div class="flex w-full bg-white">
                    <div class="w-full p-4 border-t-1 border-border-basic-2 flex justify-between">
                        <DesignButton btnType="RED" btnVariant="FILL" btnText="Delete" class="w-[6rem]" @click="deleteEducationModalOpen"/>
                        <div class="justify-end flex gap-2">
                            <DesignButton btnType="SECONDARY" btnVariant="BORDER" btnText="Cancel" class="w-[6rem]" @click="showEditPopup = false"/>
                            <DesignButton btnType="PRIMARY" btnVariant="FILL" btnText="Save" class="w-[6rem]" @click="editSaveButtonClick"/>
                        </div>
                    </div>
                </div>
            </AppPopup>
            <ElementsModal2Button v-model="showCancelCheckModal" modalTitle="" buttonText="Confirm" modalContent="Are you sure you want to delete?" @afterClick="deleteEducation" />
        </Teleport>
        <!-- Modal Edit Education END -->


        <!-- list -->
        <div>
            <div class="flex justify-between items-center my-4">
                <h4 class="font-heading-sm-semibold">Education({{ educations.length }})</h4>
                <DesignButton
                    v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn"
                    btnText="Add"
                    btnSize="SM"
                    btnType="PRIMARY"
                    btnVariant="BORDER"
                    :btnDisabled="false"
                    @click="addButtonClick"
                >
                    <template #front-icon>
                        <AddIcon :width="16" :height="16" color="text-primary-3" weight="REGULAR" />
                    </template>
                </DesignButton>
            </div>
            <div class="flex flex-col gap-2">
                <div v-for="(education, index) in educations" v-bind:key="index">
                    <div class="w-full h-auto border-1 p-4 border-border-basic-2 rounded-3 flex flex-col gap-1">
                        <div class="flex justify-between">
                            <h5 class="font-body-md-semibold">{{ education.schoolName }}</h5>
                            <DotsVerticalIcon class="h-5 w-5 text-content-basic-3 cursor-pointer" aria-hidden="true" @click="editButtonClick(education)" v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && showEditBtn" />
                        </div>
                        <div class="flex gap-1">
                            <div class="font-body-sm-medium text-content-basic-2">
                                <p v-if="!education.admissionDate || education.admissionDate === null">-</p>
                                <p v-else>
                                    {{ moment(parseInt(education.admissionDate), 'YYYYMMDD').format('MM/DD/YYYY') }}
                                </p>
                            </div>
                            <p class="font-body-sm-medium text-content-basic-3">~</p>
                            <div class="font-body-sm-medium text-content-basic-2">
                                <p v-if="!education.graduationDate || education.graduationDate === null">-</p>
                                <p v-else>
                                    {{ moment(parseInt(education.graduationDate), 'YYYYMMDD').format('MM/DD/YYYY') }}
                                </p>
                            </div>
                            <div class="font-body-sm-medium text-content-basic-2 flex ml-1">
                                (
                                    <p v-if="!education.graduationCategory">-</p>
                                    <p v-else>
                                        {{ education.graduationCategory }}
                                    </p>
                                )
                            </div>
                        </div>
                        <div class="font-body-sm-regular text-content-basic-3 flex gap-1">
                            <p>Type</p>
                            <p>:</p>
                            <p v-if="!education.degreeType">-</p>
                            <p v-else>
                                {{ education.degreeType }}
                            </p>
                        </div>
                        <div class="font-body-sm-regular text-content-basic-3 flex gap-1">
                            <p>Major</p>
                            <p>:</p>
                            <p v-if="!education.major">-</p>
                            <p v-else>
                                {{ education.major }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
/* body {
    margin: 0;
}
div {
    box-sizing: border-box;
}
.black-bg {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    padding: 20px;
}
.white-bg {
    width: 100%;
    background: white;
    border-radius: 8px;
    padding: 20px;
} */
</style>
